import { render, staticRenderFns } from "./LumiereD.vue?vue&type=template&id=458d01dc&"
import script from "./LumiereD.vue?vue&type=script&lang=js&"
export * from "./LumiereD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports